import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';

// Firebase configuration
// For full features, set all REACT_APP_FIREBASE_* env variables
// For basic push notifications, only messagingSenderId is required
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'dummy-api-key',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'foubert-app.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'foubert-app',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'foubert-app.appspot.com',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '172124196272',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:172124196272:web:dummy',
};

let app;
let messaging;

export const initializeFirebase = () => {
  if (process.env.REACT_APP_FIREBASE_DISABLED === 'true') {
    console.info('Firebase disabled via REACT_APP_FIREBASE_DISABLED');
    return;
  }

  try {
    app = initializeApp(firebaseConfig);
    messaging = getMessaging(app);
    console.info('Firebase initialized successfully');
  } catch (error) {
    console.error('Firebase initialization error:', error);
  }
}

export const getFirebaseMessaging = () => messaging;

export const askForPermissionToReceiveNotifications = async () => {
  if (!messaging) {
    return ({
      status: "FAIL",
      error: new Error("Firebase messaging not initialized")
    });
  }

  try {
    const token = await getToken(messaging, { vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY });
    return ({
      status: "SUCCESS",
      token: token
    });
  } catch (error) {
    return ({
      status: "FAIL",
      error: error
    });
  }
}